export { Storage } from './Storage';
export { localStorageAdapter } from './LocalStorageAdapter';
export { cleanDeprecatedStorages } from './cleanDeprecatedStorages';
